module.exports = __webpack_public_path__ + "img/Home_Smartphone.881beaf4.jpg";